export default __webpack_public_path__ + "static/media/12.2a3106d0.webp";